import {energy, EnergySystems, EnergyUnits, Measure} from "convert-units";

type NewEnergyUnits = EnergyUnits | 'W/h' | 'mW/h' | 'KW/h' | 'MW/h' | 'GW/h';

const newEnergy: Measure<EnergySystems, NewEnergyUnits> = {
  systems: {
    SI: {
      ...energy.systems.SI,
      'W/h': {
        name: {
          singular: 'Watt-hour',
          plural: 'Watt-hours',
        },
        to_anchor: 3600,
      },
      'mW/h': {
        name: {
          singular: 'Milliwatt-hour',
          plural: 'Milliwatt-hours',
        },
        to_anchor: 3.6,
      },
      'KW/h': {
        name: {
          singular: 'Kilowatt-hour',
          plural: 'Kilowatt-hours',
        },
        to_anchor: 3600000,
      },
      'MW/h': {
        name: {
          singular: 'Megawatt-hour',
          plural: 'Megawatt-hours',
        },
        to_anchor: 3600000000,
      },
      'GW/h': {
        name: {
          singular: 'Gigawatt-hour',
          plural: 'Gigawatt-hours',
        },
        to_anchor: 3600000000000,
      },
      J: {
        name: {
          singular: 'Joule',
          plural: 'Joules',
        },
        to_anchor: 1,
      },
      kJ: {
        name: {
          singular: 'Kilojoule',
          plural: 'Kilojoules',
        },
        to_anchor: 1000,
      },
      MJ: {
        name: {
          singular: 'Megajoule',
          plural: 'Megajoules',
        },
        to_anchor: 1000000,
      },
      GJ: {
        name: {
          singular: 'Gigajoule',
          plural: 'Gigajoules',
        },
        to_anchor: 1000000000,
      },
    },
  },
};

export default newEnergy;
